import React, { Component } from 'react'
import Link from 'components/elements/link'
import Container from 'components/elements/container'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { fontWeight } from 'themes/font'
import PublicUrl from 'components/public-url'
import { media } from 'styled-bootstrap-grid'

const Section = styled.section`
  background-image: url('/img/bg/get-started.svg');
  background-size: cover;
  background-color: #0984e3;
  padding: 64px 0;
  text-align: center;
  .headingText {
    display: block;
    margin-bottom: 16px;
    h1 {
      color: #fff;
      font-size: 32px;
      font-weight: ${fontWeight.bold} !important;
    }
  }
  ${media.md`
    .headingText {
      margin-bottom: 32px;
      h1 {
        margin-bottom: 8px;
      }
    }
  `}
`

const Button = styled(Link)`
  display: inline-block;
  background: #fff;
  border-radius: 4px;
  color: #0984e3;
  font-size: 18px;
  padding: 16px 40px;
  text-transform: uppercase;
  font-weight: ${fontWeight.bold} !important;
  border: 0;
`

export default class GetStarted extends Component {
  static propTypes = {
    isInternal: PropTypes.bool
  }

  renderHeading (heading) {
    const newHeading = heading
      .split('\n')
      .map((item, i) => <h1 key={i}>{item}</h1>)
    return newHeading
  }

  render () {
    const {
      heading,
      button: { text, link }
    } = this.props.data
    return (
      <Section>
        <Container className='wow fadeInDown'>
          <div className='headingText'>{this.renderHeading(heading)}</div>
          {this.props.isInternal ? (
            <Button to={link}>{text}</Button>
          ) : (
            <PublicUrl target='_blank' to={link}>
              <Button>{text}</Button>
            </PublicUrl>
          )}
        </Container>
      </Section>
    )
  }
}
